import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px]"
}
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = { "clip-path": "url(#clip0_2783_4779)" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = { id: "clip0_2783_4779" }
const _hoisted_8 = ["width", "height"]

import { PropType } from "vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pen',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number>,
    default: 18,
  },
  height: {
    type: Number as PropType<number>,
    default: 18,
  },
  isCallApi: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.isCallApi)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(LottieAnimation), {
          ref: "anim",
          "animation-data": _unref(ProgressAnimation),
          "auto-play": true,
          loop: true
        }, null, 8, ["animation-data"])
      ]))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        xmlns: "http://www.w3.org/2000/svg",
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 18 18",
        fill: "none"
      }, [
        _createElementVNode("g", _hoisted_3, [
          _createElementVNode("path", {
            d: "M16.445 1.87513C16.1149 1.54794 15.6899 1.33325 15.2307 1.26161C14.7714 1.18997 14.3013 1.26504 13.8872 1.47613C13.8872 1.47613 13.8515 1.40488 13.8159 1.37638L13.5594 1.09138C13.148 0.681091 12.5907 0.450684 12.0097 0.450684C11.4287 0.450684 10.8714 0.681091 10.46 1.09138L6.56266 4.98876C6.42995 5.12225 6.35547 5.30284 6.35547 5.49107C6.35547 5.6793 6.42995 5.85989 6.56266 5.99338C6.62889 6.06016 6.7077 6.11317 6.79452 6.14934C6.88135 6.18551 6.97447 6.20414 7.06853 6.20414C7.16259 6.20414 7.25572 6.18551 7.34254 6.14934C7.42937 6.11317 7.50817 6.06016 7.57441 5.99338L11.4718 2.09601C11.6156 1.95544 11.8086 1.87674 12.0097 1.87674C12.2108 1.87674 12.4039 1.95544 12.5477 2.09601L12.8113 2.35963L11.2224 3.94138C11.1536 4.01191 11.1152 4.10651 11.1152 4.20501C11.1152 4.30351 11.1536 4.39811 11.2224 4.46863L13.8373 7.07638C13.8706 7.11198 13.9109 7.14035 13.9556 7.15975C14.0003 7.17915 14.0486 7.18915 14.0973 7.18915C14.1461 7.18915 14.1943 7.17915 14.2391 7.15975C14.2838 7.14035 14.3241 7.11198 14.3574 7.07638L16.445 4.98876C16.8562 4.57495 17.087 4.01529 17.087 3.43194C17.087 2.8486 16.8562 2.28894 16.445 1.87513Z",
            fill: __props.color
          }, null, 8, _hoisted_4),
          _createElementVNode("path", {
            d: "M10.4246 5.2531C10.3553 5.18478 10.2619 5.14648 10.1645 5.14648C10.0672 5.14648 9.97379 5.18478 9.90447 5.2531L4.05484 11.1383C3.84945 11.3475 3.73437 11.6289 3.73438 11.9221C3.73438 12.2152 3.84945 12.4967 4.05484 12.7058L5.62234 14.2662C5.72499 14.3696 5.8471 14.4517 5.98161 14.5077C6.11612 14.5637 6.26039 14.5925 6.40609 14.5925C6.5518 14.5925 6.69606 14.5637 6.83057 14.5077C6.96509 14.4517 7.08719 14.3696 7.18984 14.2662L13.0537 8.40947C13.1225 8.33895 13.161 8.24434 13.161 8.14584C13.161 8.04735 13.1225 7.95274 13.0537 7.88222L10.4246 5.2531Z",
            fill: __props.color
          }, null, 8, _hoisted_5),
          _createElementVNode("path", {
            d: "M2.89263 13.1043C2.85265 13.0655 2.80398 13.0369 2.75068 13.0208C2.69739 13.0047 2.64101 13.0016 2.58625 13.0117C2.52773 13.0224 2.47312 13.0485 2.42804 13.0873C2.38296 13.1261 2.34904 13.1763 2.32975 13.2325L0.92613 17.0729C0.903041 17.1358 0.898147 17.2039 0.91201 17.2694C0.925873 17.335 0.957931 17.3953 1.0045 17.4434C1.05344 17.4911 1.11462 17.5243 1.18126 17.5394C1.2479 17.5545 1.31742 17.5509 1.38213 17.5289L5.21538 16.1253C5.26754 16.1053 5.3145 16.0737 5.35275 16.033C5.391 15.9923 5.41955 15.9435 5.43625 15.8902C5.45068 15.8311 5.44975 15.7693 5.43353 15.7107C5.41732 15.652 5.38637 15.5986 5.34363 15.5553L2.89263 13.1043Z",
            fill: __props.color
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("defs", null, [
          _createElementVNode("clipPath", _hoisted_7, [
            _createElementVNode("rect", {
              width: __props.width,
              height: __props.height,
              fill: "white"
            }, null, 8, _hoisted_8)
          ])
        ])
      ], 8, _hoisted_2))
}
}

})